// src/store/slices/canteenLogSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import canteenLogApi from 'api/canteenLogApi';

export const fetchCanteenLogs = createAsyncThunk(
  'canteenLog/fetchAll',
  async ({ page = 1, pageSize = 20, search = '' }, { rejectWithValue }) => {
    try {
      const res = await canteenLogApi.getAll(page, pageSize, search);
      return res;
    } catch (e) {
      return rejectWithValue(e.response?.data?.detail || 'Failed to load canteen logs');
    }
  }
);

const canteenLogSlice = createSlice({
  name: 'canteenLog',
  initialState: {
    logs: [],
    pagination: { count: 0, page_size: 20 },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCanteenLogs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchCanteenLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.logs = action.payload.data || [];
        state.pagination = action.payload.pagination || { count: 0, page_size: 20 };
      })
      .addCase(fetchCanteenLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = canteenLogSlice.actions;
export default canteenLogSlice.reducer;